/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 29/01/2025 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { InventariosProvider } from "./InventariosContext";

export const AllInventariosProvider = (props) => (
  <InventariosProvider>
    {props.children}
  </InventariosProvider>
);
